import type { ReactNode } from 'react';
import { splitTextWithMentions } from './mentionEmail';

export function renderMentionText(text: string, mentionClassName = 'file-review-chat__bubble-mention'): ReactNode {
  const parts = splitTextWithMentions(text);
  return parts.map((part, index) =>
    part.type === 'mention' ? (
      <span key={`m-${index}`} className={mentionClassName}>
        {part.value}
      </span>
    ) : (
      <span key={`t-${index}`}>{part.value}</span>
    )
  );
}
